import { UseCase } from '@app/core/utils/use-case.utility';
import { AuditLog, ConfigurationAuditLogRepository } from '@app/domain';
import { Observable } from 'rxjs';

export class GetConfigurationAuditLogDetailsUseCase
  implements UseCase<number, AuditLog>
{
  readonly SERVICE_NAME = 'GetConfigurationAuditLogDetailsUseCase';

  constructor(
    private readonly _configurationAuditLogRepository: ConfigurationAuditLogRepository
  ) {}

  execute(id: number): Observable<AuditLog> {
    return this._configurationAuditLogRepository.getConfigurationAuditLogItem(
      id
    );
  }
}
